import { render } from "./FrmManageShoppingLocationIndex.vue?vue&type=template&id=666ac03f"
import script from "./FrmManageShoppingLocationIndex.vue?vue&type=script&lang=js"
export * from "./FrmManageShoppingLocationIndex.vue?vue&type=script&lang=js"

import "./FrmManageShoppingLocationIndex.vue?vue&type=style&index=0&id=666ac03f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__